import { messageDayLabel } from "@/lib/conversations";

/** Separador de día entre mensajes («Hoy», «Ayer», «Lunes», «12 de octubre»),
 *  como en WhatsApp. Lo usan el inbox de Conversaciones, el de soporte de
 *  plataforma y la ventana del botón flotante. */
export default function ConversationDaySeparator({
  createdAt,
}: {
  createdAt: string;
}) {
  return (
    <div className="flex justify-center py-1">
      <span className="text-[11px] font-medium text-gray-600 bg-white border border-gray-200 shadow-sm px-2.5 py-0.5 rounded-lg">
        {messageDayLabel(createdAt)}
      </span>
    </div>
  );
}
